import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import { FileText, Trash2 } from 'lucide-react';
import RendicionViaticosService from '../../axios_services/rendicion_viaticos.service';

const ModalArchivosAdjuntos = ({ isOpen, onClose, rendicion }) => {
    const [archivos, setArchivos] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isOpen && rendicion) {
            fetchArchivos();
        } else {
            setArchivos([]);
        }
    }, [isOpen, rendicion]);

    const fetchArchivos = async () => {
        setLoading(true);
        try {
            const response = await RendicionViaticosService.getArchivosAdjuntos(rendicion.rendicion_id);
            if (response.success) {
                setArchivos(response.data);
            }
        } catch (error) {
            console.error('Error al obtener archivos:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={onClose} className="custom-modal" size="md">
            <ModalHeader className="modal-header">
                <div className="titulo">
                    <h1>COMPROBANTES</h1>
                    <Button className="close-btn" onClick={onClose}>X</Button>
                </div>
            </ModalHeader>
            <ModalBody className="modal-body" style={{ color: '#333', fontSize: '14px', padding: '1.5rem 2rem' }}>
                <p className="mb-3 text-muted">A continuación se listan los comprobantes adjuntos de la rendición:</p>
                {loading ? (
                    <p className="text-center text-muted">Cargando comprobantes...</p>
                ) : (
                    <div className="flex flex-col gap-2">
                        {archivos.map((archivo, index) => (
                            <div key={archivo.archivo_id} className="flex items-center justify-between p-3 border rounded shadow-sm bg-white">
                                <div className="flex items-center gap-2">
                                    <FileText size={18} className="text-primary" />
                                    <span className="font-semibold text-sm">
                                        Comprobante {index + 1}
                                    </span>
                                </div>
                                <div className="flex gap-2">
                                    <Button 
                                        color="primary" 
                                        size="sm" 
                                        onClick={() => window.open(archivo.url_completa, '_blank')}
                                        style={{ fontSize: '12px', padding: '4px 10px' }}
                                    >
                                        Abrir
                                    </Button>
                                </div>
                            </div>
                        ))}
                        {archivos.length === 0 && (
                            <p className="text-center text-muted">No hay comprobantes adjuntos en esta rendición.</p>
                        )}
                    </div>
                )}
            </ModalBody>
        </Modal>
    );
};

export default ModalArchivosAdjuntos;
